import _extends from 'babel-runtime/helpers/extends';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _isNil from 'lodash/isNil';
/* eslint-disable react/prop-types  */
import events from '@wh/quick-deposit/es/main/events';

import React, { Component, lazy, Suspense } from 'react';
import { DEPOSIT, NONE, QUICK_DEPOSIT } from '../deposit-common/constants';
import { mapQuickDepositEventsToSiteBaseEvents } from '../deposit-common/mappings';
import { eventClosed, eventOpened, onCommandClose, onCommandOpen, onCommandUpdateAmount } from '../deposit-common/message-bus-helpers';
import { publish, subscribe, unsubscribe } from '../patched-message-bus';

var type = '@sitebase/deposit';

var QuickDeposit = lazy(function () {
  return import('../deposit-common/QuickDeposit');
});
var StandardDeposit = lazy(function () {
  return import('../deposit-common/StandardDeposit');
});

var DepositJourneys = function (_Component) {
  _inherits(DepositJourneys, _Component);

  function DepositJourneys() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DepositJourneys);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DepositJourneys.__proto__ || _Object$getPrototypeOf(DepositJourneys)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      amount: null,
      closeOnSuccess: null,
      currentVisibleDeposit: NONE,
      customDepositUrl: '',
      eventSource: null,
      submitTextKey: null,
      pmtSource: null
    }, _this.updateAmount = function (_ref2) {
      var amount = _ref2.amount;
      return _this.setState({ amount: amount });
    }, _this.handleOpenModal = function (_ref3) {
      var closeOnSuccess = _ref3.closeOnSuccess,
          eventSource = _ref3.eventSource,
          submitTextKey = _ref3.submitTextKey,
          depositType = _ref3.type,
          url = _ref3.url,
          pmtSource = _ref3.pmtSource;

      var isIosWrapperPresent = null;
      if (typeof window !== 'undefined') {
        var userAgent = window.navigator.userAgent;
        isIosWrapperPresent = userAgent.includes('5eaaadc3-3145-4490-a4d8-db9bdf9d4182') || userAgent.includes('c99a9785-8a16-4801-9474-02b5a8fbb58e');
      }
      if (isIosWrapperPresent) {
        _this.setState({
          currentVisibleDeposit: NONE,
          customDepositUrl: ''
        });
        window.open(url || _this.props.depositUrl);
      } else {
        _this.setState({
          closeOnSuccess: closeOnSuccess,
          currentVisibleDeposit: depositType,
          customDepositUrl: url,
          eventSource: eventSource,
          submitTextKey: submitTextKey,
          pmtSource: pmtSource
        }, function () {
          return publish(eventOpened({ type: depositType }));
        });
      }
    }, _this.handleCloseModal = function (_ref4) {
      var _ref4$type = _ref4.type,
          depositType = _ref4$type === undefined ? QUICK_DEPOSIT : _ref4$type;

      _this.setState({
        currentVisibleDeposit: NONE,
        customDepositUrl: ''
      }, function () {
        return publish(eventClosed({ type: depositType }));
      });
    }, _this.closeQuickDepositModal = function () {
      return _this.handleCloseModal({ type: QUICK_DEPOSIT });
    }, _this.closeDepositModal = function () {
      return _this.handleCloseModal({ type: DEPOSIT });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DepositJourneys, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.subscribeIds = [subscribe(onCommandOpen(this.handleOpenModal)), subscribe(onCommandClose(this.handleCloseModal)), subscribe(onCommandUpdateAmount(this.updateAmount)), subscribe(events.MESSAGE_PUB_QD_CLOSE, this.closeQuickDepositModal)].concat(_toConsumableArray(mapQuickDepositEventsToSiteBaseEvents()));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.subscribeIds && this.subscribeIds.length) {
        this.subscribeIds.forEach(function (subscribeId) {
          return unsubscribe(subscribeId);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          amount = _state.amount,
          closeOnSuccess = _state.closeOnSuccess,
          currentVisibleDeposit = _state.currentVisibleDeposit,
          customDepositUrl = _state.customDepositUrl,
          eventSource = _state.eventSource,
          submitTextKey = _state.submitTextKey,
          pmtSource = _state.pmtSource;


      if (currentVisibleDeposit === QUICK_DEPOSIT) {
        return React.createElement(
          Suspense,
          { fallback: null },
          React.createElement(QuickDeposit, _extends({}, this.props, {
            amount: _isNil(amount) ? this.props.amount : amount,
            closeOnSuccess: closeOnSuccess,
            eventSource: eventSource,
            key: 'quick-deposit.modal',
            onCloseRequest: this.closeQuickDepositModal,
            submitTextKey: submitTextKey,
            pmtSource: _isNil(pmtSource) ? this.props.pmtSource : pmtSource
          }))
        );
      }
      if (currentVisibleDeposit === DEPOSIT) {
        return React.createElement(
          Suspense,
          { fallback: null },
          React.createElement(StandardDeposit, {
            depositUrl: customDepositUrl || this.props.depositUrl,
            onModalCloseRequested: this.closeDepositModal,
            key: 'pih.deposit.modal'
          })
        );
      }
      return null;
    }
  }]);

  return DepositJourneys;
}(Component);

export default {
  type: type,
  renderToPortal: function renderToPortal(_ref5) {
    var data = _ref5.data;
    return React.createElement(DepositJourneys, _extends({ key: 'pih.deposit' }, data));
  }
};
//# sourceMappingURL=deposit.js.map